import React from 'react';
import { Sparkles } from 'lucide-react';

interface LogoProps {
    title?: string;
    variant?: 'default' | 'light';
}

const Logo: React.FC<LogoProps> = ({ title = "Echoo.ai", variant = "default" }) => {
    const isLight = variant === 'light';

    return (
        <div className="flex items-center mb-6">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center mr-3">
                <Sparkles className={`w-6 h-6 ${isLight ? 'text-white fill-white' : 'text-purple-500 fill-purple-500'}`} />
            </div>
            <span className={`text-2xl font-semibold ${isLight ? 'text-white' : 'text-slate-900'}`}>{title}</span>
        </div>
    );
};

export default Logo;
